import logo from "../../assets/logo.png";
import classes from "./AplicationForm.module.css";
import HorizontalLinearStepper from "../../components/Stepper/HorizontalLinearStepper";
import ButtonStepper from "../../components/ButtonStepper/ButtonStepper";
import { useEffect, useState } from "react";
import Card from "../../components/Card/Card";
import PersonalForm from "../FormsSteps/Personal/PersonalForm";
import { steps } from "../../DummyData/DUMMYDATA";
import FinishedAplication from "../FinishedAplication/FinishedAplication";
import EducationForm from "../FormsSteps/Education/EducationForm";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import SnackbarComponent from "../../components/Snackbar/Snackbar";
import { apiEndpoint } from "../../DummyData/DUMMYDATA";
import Declaration from "../FormsSteps/Declaration/Declaration";
import { useTranslation } from "../../I18n/Languages/LanguageContext";
import LanguageSwitcher from "../../components/LanguageSwitcher/LanguageSwitcher";
import { getSteps } from "../../utils/translatedOptions";
import { useNavigation } from "../../components/NavigationContext/NavigationContext";
import { emptyWorkExperience, initialFormData } from "../../utils/FormDefaults";
import {
  validateDeclarationForm,
  validateEducationForm,
  validatePersonalForm,
} from "../../utils/StepsValidation";
import { createApplicant } from "../../utils/CreateAplication";

function ApplicationForm() {
  const { t, language } = useTranslation();
  const translatedSteps = getSteps(t);
  const [activeStep, setActiveStep] = useState(0);
  const navigate = useNavigate();
  const { allowSuccessAccess } = useNavigation();

  const location = useLocation();
  const isWorkForce = location.state?.isWorkForce || false;
  const jobId = location.state?.jobId;

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [activeStep]);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const showSnackbar = (message, severity = "success") => {
    setSnackbar({
      open: true,
      message,
      severity,
    });
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const [formData, setFormData] = useState(() => ({
    ...initialFormData,
    pozicioni: jobId,
  }));

  const updateFormData = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const updateWorkExperienceEntry = (index, field, value) => {
    const updatedWorkExperience = [...formData.workExperience];
    updatedWorkExperience[index][field] = value;
    setFormData((prev) => ({
      ...prev,
      workExperience: updatedWorkExperience,
    }));
  };

  const addWorkExperienceEntry = () => {
    setFormData((prev) => ({
      ...prev,
      workExperience: [
        ...prev.workExperience,
        {
          id: uuidv4(),
          employerName: "",
          position: "",
          startDate: "",
          endDate: "",
          responsibilities: "",
          employmentReasonForLeaving: "",
        },
      ],
    }));
  };

  const removeWorkExperienceEntry = (id) => {
    const updatedWorkExperience = formData.workExperience.filter(
      (entry) => entry.id !== id
    );

    if (updatedWorkExperience.length === 0) {
      updatedWorkExperience.push({ ...emptyWorkExperience, id: uuidv4() });
    }

    setFormData((prev) => ({
      ...prev,
      workExperience: updatedWorkExperience,
    }));
  };

  const updateLanguageEntry = (index, field, value) => {
    const updatedLanguage = [...formData.foreignLanguages];
    updatedLanguage[index][field] = value;
    setFormData((prev) => ({
      ...prev,
      foreignLanguages: updatedLanguage,
    }));
  };

  const addLanguageEntry = () => {
    setFormData((prev) => ({
      ...prev,
      foreignLanguages: [
        ...prev.foreignLanguages,
        {
          id: uuidv4(),
          language: "",
          level: "",
        },
      ],
    }));
  };

  const removeLanguageEntry = (id) => {
    if (formData.foreignLanguages.length > 1) {
      setFormData((prev) => ({
        ...prev,
        foreignLanguages: prev.foreignLanguages.filter(
          (entry) => entry.id !== id
        ),
      }));
    }
  };

  async function uploadFileAndSetFormData(file, fieldName, successMessage) {
    const headers = {
      "Content-Type": "application/octet-stream",
      "X-File-Size": file.size.toString(),
      "X-File-Type": file.type,
      "X-File-Name": file.name,
      "X-File-Offset": "0",
    };

    try {
      const response = await axios.post(`${apiEndpoint}/upload-cv`, file, {
        headers,
      });

      if (response.data && response.data.id) {
        updateFormData(fieldName, {
          id: response.data.id,
          name: file.name,
          type: file.type,
          size: file.size,
          fileObject: file,
        });
        showSnackbar(
          successMessage || "File uploaded successfully!",
          "success"
        );
        return response.data;
      } else {
        showSnackbar("File upload failed - no ID received", "error");
        updateFormData(fieldName, null);
      }
    } catch (error) {
      console.error("Upload failed:", error);
      updateFormData(fieldName, null);
      showSnackbar("File upload failed. Please try again.", "error");
      throw error;
    }
  }

  const uploadCoverLetterFile = (file) =>
    uploadFileAndSetFormData(
      file,
      "coverLetterFile",
      "Cover letter uploaded successfully!"
    );

  const uploadCVFile = (file) =>
    uploadFileAndSetFormData(file, "cvFile", "CV uploaded successfully!");


  const uploadPhotoFile = (file) =>
    uploadFileAndSetFormData(file, "photoFile", "Photo uploaded successfully!");




const handleSubmit = async () => {
  
  try {

      const formDataWithLanguage = {
        ...formData,
        language, 
      };
    await createApplicant(formDataWithLanguage);

    allowSuccessAccess();
    sessionStorage.setItem("successPageAccess", "true");
    navigate("/Success");
  } catch (error) {
    console.error("❌ Error in handleSubmit:", error);
    showSnackbar(t("application_send_error"), "error");
  }
};
  const [jobsPositions, setJobsPositions] = useState([]);

  const jobOptions = Array.from(
    new Map(
      jobsPositions.map((job) => [job.jobTitle, { label: job.jobTitle, value: job.id }])
    ).values()
  );

  useEffect(() => {
    const fetchJobListings = async () => {
      try {
        const [externalRes, bothRes] = await Promise.all([
          axios.get(`${apiEndpoint}/job-listings/type/external`),
          axios.get(`${apiEndpoint}/job-listings/type/both`),
        ]);
        const combined = [
          ...(externalRes.data.data || []),
          ...(bothRes.data.data || []),
        ];
        const seen = new Set();
        const jobs = combined.filter((job) => {
          if (job.publicationType === "internal") return false;
          if (seen.has(job.id)) return false;
          seen.add(job.id);
          return true;
        });
        setJobsPositions(jobs);

        if (jobId && jobId !== "") {
          const matchedJob = jobs.find((job) => job.id === jobId);
          if (matchedJob) {
            updateFormData("pozicioni", matchedJob.id);
          }
        }
      } catch (error) {
        console.error(t("error_fetching_jobs"), error);
      }
    };

    fetchJobListings();
  }, [jobId, t]);

  return (
    <>
      <div
        style={{
          position: "absolute",
          top: window.innerWidth <= 768 ? "2px" : "20px",
          right: window.innerWidth <= 768 ? "2px" : "20px",
        }}
      >
        <LanguageSwitcher />
      </div>
      <div className={classes.container}>
        <Card>
          <div className={classes.header}>
            <h1>
              <span className={classes.h1black}>{t("form")} </span>
              <span className={classes.h1red}>{t("application")}</span>
            </h1>
            <img src={logo} alt="logo" className={classes.logo} />
          </div>

          <HorizontalLinearStepper
            activeStep={activeStep}
            steps={translatedSteps}
          />

          {activeStep !== 3 && (
            <h3 className={classes.h3red}>{translatedSteps[activeStep]}</h3>
          )}
          <div className={classes.formContent}>
            {activeStep === 0 && (
              <PersonalForm
                formData={formData}
                updateFormData={updateFormData}
                setFormData={setFormData}
                workExperience={formData.workExperience}
                jobOptions={jobOptions}
                jobsPositions={jobsPositions}
                uploadCoverLetterFile={uploadCoverLetterFile}
                uploadCVFile={uploadCVFile}
                uploadPhotoFile={uploadPhotoFile}
              />
            )}
            {activeStep === 1 && (
              <EducationForm
                isWorkForce={isWorkForce}
                workExperience={formData.workExperience}
                updateWorkExperienceEntry={updateWorkExperienceEntry}
                addWorkExperienceEntry={addWorkExperienceEntry}
                removeWorkExperienceEntry={removeWorkExperienceEntry}
                languages={formData.foreignLanguages}
                updateLanguageEntry={updateLanguageEntry}
                addLanguageEntry={addLanguageEntry}
                removeLanguageEntry={removeLanguageEntry}
                computerPrograms={formData.computerPrograms}
                setComputerPrograms={(value) =>
                  updateFormData("computerPrograms", value)
                }
                computerSkillsData={formData.computerSkillsData}
                setComputerSkillsData={(value) =>
                  updateFormData("computerSkillsData", value)
                }
                formData={formData}
                updateFormData={updateFormData}
              />
            )}

            {activeStep === 2 && (
              <Declaration
                formData={formData}
                updateFormData={updateFormData}
              />
            )}

            {activeStep === 3 && (
              <FinishedAplication
                formData={formData}
                jobOptions={jobOptions}
                updateFormData={updateFormData}
                onBack={handleBack}
                onSubmit={handleSubmit}
              />
            )}
          </div>
          {activeStep < 3 && (
            <>
              <div className={classes.divider}></div>
              <ButtonStepper
                activeStep={activeStep}
                stepsLength={steps.length}
                onNext={handleNext}
                onBack={handleBack}
                isPersonalFormValid={
                  activeStep === 0 ? validatePersonalForm(formData) : true
                }
                isEducationFormValid={
                  activeStep === 1
                    ? validateEducationForm(formData, isWorkForce)
                    : true
                }
                isDeclarationFormValid={
                  activeStep === 2 ? validateDeclarationForm(formData) : true
                }
              />
            </>
          )}
          <SnackbarComponent
            open={snackbar.open}
            message={snackbar.message}
            severity={snackbar.severity}
            onClose={handleSnackbarClose}
          />
        </Card>
      </div>
    </>
  );
}

export default ApplicationForm;
